import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function detail(pk) {
  const { data } = await axios.get(routes.customersShow(pk), AXIOS_DEFAULT_CONFIG);
  return data
}
